"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _proptypes = require("../utils/proptypes");

var _element = require("../utils/dom/element");

var _styles = require("../styles");

var _context = require("./context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Card =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Card, _PureComponent);

  function Card(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      collapsed: props.defaultCollapsed,
      formStatus: ''
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setFormStatus = _this.setFormStatus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Card.prototype;

  _proto.getCollapsed = function getCollapsed() {
    var _this$props = this.props,
        collapsible = _this$props.collapsible,
        collapsed = _this$props.collapsed;
    if (!collapsible) return undefined;
    return collapsed !== undefined ? collapsed : this.state.collapsed;
  };

  _proto.setFormStatus = function setFormStatus(status) {
    if (status !== this.state.formStatus) {
      this.setState({
        formStatus: status
      });
    }
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.handleCollapse = function handleCollapse() {
    var collapsed = !this.getCollapsed();
    if (this.props.onCollapse) this.props.onCollapse(collapsed);else this.setState({
      collapsed: collapsed
    });
  };

  _proto.handleSubmit = function handleSubmit() {
    var form = this.element.querySelector('form');
    if (form) (0, _element.dispatchEvent)(form, 'submit');else console.error(new Error('No form found.'));
  };

  _proto.render = function render() {
    var collapsible = this.props.collapsible;
    var collapsed = this.getCollapsed();
    var shadow = this.props.shadow === true ? 'shadow' : this.props.shadow;
    var className = (0, _classnames.default)((0, _styles.cardClass)('_', shadow, collapsible && 'collapsible', collapsed && 'collapsed'), this.props.className);
    var provierValue = {
      onCollapse: this.handleCollapse,
      collapsible: collapsible,
      collapsed: collapsed,
      formStatus: this.state.formStatus,
      onSubmit: this.handleSubmit,
      setFormStatus: this.setFormStatus
    };
    return _react.default.createElement("div", {
      className: className,
      ref: this.bindElement,
      style: this.props.style
    }, _react.default.createElement(_context.Provider, {
      value: provierValue
    }, this.props.children));
  };

  return Card;
}(_react.PureComponent);

Card.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  shadow: _propTypes.default.oneOf([true, false, 'hover'])
});
Card.defaultProps = _objectSpread({}, _proptypes.defaultProps, {
  defaultCollapsed: true,
  collapsible: false
});
var _default = Card;
exports.default = _default;